import Api from '@/services/Api'

export default {
  uploadfile (data, config) {
    console.log('uploading files')
    return Api().post('attachedfiles/create', data, config)
  },
  uploadreviewfile (data, config) {
    console.log('uploading review files')
    return Api().post('review/create', data, config)
  },
  uploadreviewcommitteefile (data, config) {
    console.log('uploading review files committee')
    return Api().post('review/createcommittee', data, config)
  },
  getfilelist () {
    const filelist = []
    // Api().get('attachedfiles/view?application_id=' + data, this.$store.state.configheader)
    Api().get('attachedfiles/view?application_id=8', this.$store.state.configheader)
      .then(response => {
        if (response.status) {
          response.data.filelist.forEach(element => {
            this.attachmentlist.push({name: element.name, size: 2200000, lastModified: '2017-01-11'})
          })
          return filelist
        } else {
          console.log('Unsuccessful filelist view')
        }
      })
      .catch(e => {
        if (e.response.status === 401) {
          this.$toastr('error', 'Your session has expired, please login again!', 'Logged out')
          this.$store.state.auth.logout()
        }
      })
  },
  deletefile (data) {
    console.log('delete file')
    return Api().delete('attachedfiles/delete', data)
  },
  createapplication (data, config) {
    console.log('create application')
    return Api().post('application/create', data, config)
  },
  updateapplication (data, config) {
    console.log('update application')
    return Api().post('application/update', data, config)
  },
  getapplicationslist (config) {
    console.log('get applications list')
    return Api().get('application/view', config)
  }
}



// WEBPACK FOOTER //
// ./src/services/FilesService.js